module.exports = __webpack_public_path__ + "img/stt-not-valid.0f6f4077.svg";